import React from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const CommonDialog = props => {
  return (
    <Dialog
      fullScreen={props.fullScreen || false}
      disableBackdropClick={props.disableBackdropClick || true}
      onBackdropClick={props.onBackdropClick}
      onClose={props.onClose}
      maxWidth={props.maxWidth || "lg"}
      fullWidth={props.fullWidth || false}
      open={props.open}
      style={props.style}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {props.title && (
        <DialogTitle
          style={{
            backgroundColor: props.backgroundTitle || "rgb(241, 206, 47)",
            zIndex: 9999,
            marginBottom: props.margin || "15px",
            //minWidth: "350px",
            height: "auto"
          }}
          id="alert-dialog-title"
        >
          {props.title}
        </DialogTitle>
      )}
      <DialogContent
        className={props.scssClass || "commonDialog_content"}
        style={props.contentStyle}
      >
        <DialogContentText
          className="commonDialog_contentText"
          id="alert-dialog-description"
          style={{
            width: "auto",
            height: "auto"
          }}
        >
          {props.contentText}
        </DialogContentText>
        {!props.hideIcon && (
          <div>
            <img
              src={props.contentIcon}
              alt={props.iconAlt}
              style={{ maxWidth: "50px", maxHeight: "50px" }}
            />
          </div>
        )}
        {props.children}
      </DialogContent>
      <DialogActions>
        {props.extraButtons}
        {props.noAceptar ? null : (
          <Button
            id="btnDialogAcept"
            disabled={props.disabledAceptar}
            onClick={props.onClickAceptar}
            color="primary"
          >
            {props.aceptarText || "Aceptar"}
          </Button>
        )}
        {props.noCancelar ? null : (
          <Button
            id="btnDialogCancel"
            disabled={props.disabledCancelar}
            onClick={props.onClickCancelar}
            style={props.disabledAceptar || props.disabledCancelar ? { } : { backgroundColor: "rgb(28, 86, 187)", color: "white", placeSelf: "normal" }}
            color="primary"
          >
            {props.cancelarText || "Cancelar"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CommonDialog;
